import i18next from "i18next";
import { toast } from "react-toastify";
import { PATH } from "../../router/constants/Path";
import { boundReplaceLocObj } from "../../router/actions/routesActions";
import { getLangCountry } from "../../router/scripts/link";
import { logger } from "../../common/scripts/logger/log";

function isNetworkFetchError(error: unknown): boolean {
  return (
    error instanceof TypeError &&
    error.message === "NetworkError when attempting to fetch resource."
  );
}

export function handlePlaceOrderError(error: unknown, orderId: string, orderNumber?: number): void {
  const message = i18next.t("ORDER CREATION FAILED", { orderNumber: orderNumber ?? "-" });
  toast.error(message, { position: "top-center" });

  if (!isNetworkFetchError(error)) {
    logger.warn(message, { exception: error });
  }

  boundReplaceLocObj({
    pathname: `${getLangCountry()}/${PATH.ORDER}/${orderId}`,
  });
}
